<div class="chat-flight-details" [class.chat-flight-details--locked]="locked">
  @if (locked && chosenSummary) {
    <div class="chat-flight-details__chosen">{{ chosenSummary }}</div>
  } @else {
    <label class="chat-flight-details__field">
      <span>Flight carrier</span>
      <input
        type="text"
        aria-label="Flight carrier"
        autocomplete="off"
        [disabled]="locked"
        [(ngModel)]="carrierModel"
        (ngModelChange)="onCarrierModelChange($event)"
        (focus)="focus$.next($any($event.target).value)"
        [ngbTypeahead]="carriers"
        (selectItem)="onCarrierSelected($event)"
        [resultTemplate]="carrierTemplate"
        [inputFormatter]="formatterCarriers"
        placeholder="Start typing an airline..."
      />
      <ng-template #carrierTemplate let-result="result">
        {{ result.title }} ({{ result.value }})
      </ng-template>
    </label>
    <label class="chat-flight-details__field">
      <span>Flight number (numeric value only)</span>
      <input
        type="text"
        inputmode="numeric"
        autocomplete="off"
        [disabled]="locked"
        [(ngModel)]="flightNumber"
        (input)="onFlightNumberInput($event)"
        pattern="[0-9]*"
        placeholder="e.g. 123"
        title="Enter numbers only"
      />
    </label>
    <div class="chat-flight-details__actions">
      @if (!required) {
        <button
          type="button"
          class="chat-flight-details__skip"
          [disabled]="locked"
          (click)="onSkip()"
        >
          Skip
        </button>
      }
      <button
        type="button"
        class="chat-flight-details__continue"
        [disabled]="locked || !isValid"
        (click)="onContinue()"
      >
        Continue
      </button>
    </div>
  }
</div>
